import Config from "./config.js"

export default {
      /**
     * 手机号脱敏方法
     */

        getRegular(num) {
            let nums;
            if (num.indexOf('@') == -1) {
                nums = num.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
            } else {
                // 替换邮箱字符
                if (String(num).indexOf('@') > 0) {
                    let str = num.split('@'),
                        _s = ''
                    if (str[0].length > 3) {
                   
                        for (let i = 0; i < str[0].length - 3; i++) {
                            _s += '*'
                        }
                    }
                    
                    nums = str[0].substr(0, 3) + _s + '@' + str[1]
                }
            }
            return nums
        },
    /**
     * 图片路径转换
     * @param {String} img_path 图片地址
     * @param {Object} params 参数，针对商品、相册里面的图片区分大中小，size: big、mid、small
     */
    img(img_path, params) {
        var path = ""
        if (img_path != undefined && img_path != "") {
            if (params && img_path != vue.$store.getters.defaultGoodsImage) {
                // 过滤默认图
                let arr = img_path.split(".")
                let suffix = arr[arr.length - 1]
                arr.pop()
                arr[arr.length - 1] = arr[arr.length - 1] + "_" + params.size
                arr.push(suffix)
                img_path = arr.join(".")
            }
			if (img_path.indexOf("http://") == -1 && img_path.indexOf("https://") == -1) {
				path = Config.imgDomain + "/" + img_path;
				
			} else {
				if(img_path.indexOf(Config.imgDomain) == -1){
					if(params){
						path = img_path;
						path = path.replace("_" + params.size,'')
					}else{
						path = img_path
					}
				}else{
				path = img_path;	
				}
			
			}
        }
        return path
    },
    /**
     * 时间戳转日期格式
     * @param {Object} timeStamp
     */
    timeStampTurnTime(timeStamp) {
        if (timeStamp != undefined && timeStamp != "" && timeStamp > 0) {
            var date = new Date()
            date.setTime(timeStamp * 1000)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? "0" + m : m
            var d = date.getDate()
            d = d < 10 ? "0" + d : d
            var h = date.getHours()
            h = h < 10 ? "0" + h : h
            var minute = date.getMinutes()
            var second = date.getSeconds()
            minute = minute < 10 ? "0" + minute : minute
            second = second < 10 ? "0" + second : second
            return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second
        } else {
            return ""
        }
    },
    /**
     * 倒计时
     * @param {Object} seconds 秒
     */
    countDown(seconds) {
        let [day, hour, minute, second] = [0, 0, 0, 0]
        if (seconds > 0) {
            day = Math.floor(seconds / (60 * 60 * 24))
            hour = Math.floor(seconds / (60 * 60)) - day * 24
            minute = Math.floor(seconds / 60) - day * 24 * 60 - hour * 60
            second = Math.floor(seconds) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day < 10) {
            // day = '0' + day
        }
        if (hour < 10) {
            // hour = '0' + hour
        }
        if (minute < 10) {
            // minute = '0' + minute
        }
        if (second < 10) {
            // second = '0' + second
        }
        return {
            d: day,
            h: hour,
            i: minute,
            s: second
        }
    },
    /**
     * 数值去重
     * @param {Array} arr 数组
     * @param {string} field 字段
     */
    unique(arr, field) {
        const res = new Map()
        return arr.filter(a => !res.has(a[field]) && res.set(a[field], 1))
    },
    /**
     * 判断值是否在数组中
     * @param {Object} elem
     * @param {Object} arr
     * @param {Object} i
     */
    inArray: function(elem, arr) {
        return arr == null ? -1 : arr.indexOf(elem)
    },
            getOs:function(){  
                var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
                var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
                var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
                var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
                var isSafari = userAgent.indexOf("Safari") > -1
                        && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
                var isChrome = userAgent.indexOf("Chrome") > -1
                        && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器
                if (isOpera) {
                    return "Opera";
                }
                if (isEdge) {
                    return "Edge";
                }
                if (isFF) {
                    return "Firefox";
                }
                if (isSafari) {
                    return "Safari";
                }
                if (isChrome) {
                    return "Chrome";
                }
            
        },
    /**
     * 获取某天日期
     * @param {Object} day
     */
    getDay: function(day) {
        var today = new Date()
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
        today.setTime(targetday_milliseconds)

        const doHandleMonth = function(month) {
            var m = month
            if (month.toString().length == 1) {
                m = "0" + month
            }
            return m
        }

        var tYear = today.getFullYear()
        var tMonth = today.getMonth()
        var tDate = today.getDate()
        var tWeek = today.getDay()
        var time = parseInt(today.getTime() / 1000)
        tMonth = doHandleMonth(tMonth + 1)
        tDate = doHandleMonth(tDate)

        const week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
        return {
            t: time,
            y: tYear,
            m: tMonth,
            d: tDate,
            w: week[tWeek]
        }
    },
    /**
     * 复制
     * @param {Object} message
     * @param {Object} callback
     */
    copy(value, callback) {
        var oInput = document.createElement("input") //创建一个隐藏input（重要！）
        oInput.value = value //赋值
        document.body.appendChild(oInput)
        oInput.select() // 选择对象
        document.execCommand("Copy") // 执行浏览器复制命令
        oInput.className = "oInput"
        oInput.style.display = "none"
        vue.$message({
            message: "复制成功",
            type: "success"
        })
        typeof callback == "function" && callback()
    },
    /**
     * 深度拷贝对象
     * @param {Object} obj
     */
    deepClone(obj) {
        const isObject = function(obj) {
            return typeof obj == "object"
        }

        if (!isObject(obj)) {
            throw new Error("obj 不是一个对象！")
        }
        //判断传进来的是对象还是数组
        let isArray = Array.isArray(obj)
        let cloneObj = isArray ? [] : {}
        //通过for...in来拷贝
        for (let key in obj) {
            cloneObj[key] = isObject(obj[key]) ? this.deepClone(obj[key]) : obj[key]
        }
        return cloneObj
    },
    /**
     * 上传图片限制大小
     * @param {Object} obj
     */
     dataURItoBlob(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for(var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: type});
      },
    beforeUpload(file) { // 文件上传前钩子
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' //图片格式是否为png或jpg
        const isLt10M = file.size / 1024 / 1024 < 60 //判断图片大小是否超过5MB
        if (!isJpgOrPng) {
          this.$message.error('文件格式错误！')
        } else if(!isLt10M) {
          this.$message.error('文件过大！')
        } else {
        //   const _this = this
        //   return new Promise(resolve => {
        //     const reader = new FileReader()
        //     const image = new Image()
        //     image.onload = () => {
        //       const canvas = document.createElement('canvas');
        //       const context = canvas.getContext('2d');
        //       const originWidth = image.width
        //       const originHeight = image.height
        //       // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        //       let maxWidth = 1920, maxHeight = 1080
        //       // 目标尺寸
        //       let targetWidth = originWidth, targetHeight = originHeight
        //       // 图片尺寸超过1920x1080的限制
        //       if (originWidth > maxWidth || originHeight > maxHeight) {
        //         if (originWidth / originHeight > maxWidth / maxHeight) {
        //           // 更宽，按照宽度限定尺寸
        //           targetWidth = maxWidth;
        //           targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        //         } else {
        //           targetHeight = maxHeight;
        //           targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        //         }
        //       }
        //       canvas.width = targetWidth
        //       canvas.height = targetHeight
        //       context.clearRect(0, 0, targetWidth, targetHeight)
        //       context.drawImage(image, 0, 0, targetWidth, targetHeight)
        //       const dataUrl = canvas.toDataURL('image/jpeg', 0.8)
        //       const blobData = _this.$util.dataURItoBlob(dataUrl, 'image/jpeg')
        //       resolve(blobData)
        //     }
        //     reader.onload = (e => { image.src = e.target.result; })
        //     reader.readAsDataURL(file)
        //   })
        }
        return isJpgOrPng && isLt10M
      },
      downloadIamge(imgsrc, name) {
        //下载图片地址和图片名
        var image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
            var canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            var context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
            var a = document.createElement("a"); // 生成一个a元素
            var event = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window
            }); // 创建一个单击事件
            a.download = name || "个人简历"; // 设置图片名称
            a.href = url; // 将生成的URL设置为a.href属性
            a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
    },
    //   base64下载图片
    downloadFile(fileName, content) {
        let aLink = document.createElement('a');
        let blob = this.base64ToBlob(content); //new Blob([content]);
 
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        aLink.download = fileName;
        aLink.href = URL.createObjectURL(blob);
        aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));//兼容火狐
    },
    base64ToBlob(dataurl) {
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
        return new Blob([u8arr], { type: mime });
    },
        /**
     * 封装提示信息
     */
         Notifi(text,type,icon){
            vue.$toasted.show(text,{theme:'toasted-primary',position:'top-center',duration:1500,type:type,iconPack:'fontawesome',icon:icon})
        },
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        getResourceType(url) {
            const extension = url.split('.').pop().toLowerCase(); 
            if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') 
            { return 'img'; }
             else if (extension === 'pdf') 
            { return 'pdf'; } 
            else { return 'unknown'; } 
        },
        ddShowMenu(title, img, content) {
            dd.ready(function() {
              dd.biz.navigation.setRight({
                show: true, 
                control: true, 
                text: '', //空字符串表示显示默认文本
                onSuccess: function(result) {
                  dd.biz.util.share({
                    type: 0, //分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
                    content: content,
                    title: title,
                    image: img,
                    onSuccess: function() {},
                    onFail: function(err) {}
                  })
                },
                onFail: function(err) {}
              });
            })
          },
              // 获取当前时间并格式化
    formatDate(format) {
        let date = new Date();
        let year = date.getFullYear(); // 年
        let month = date.getMonth() + 1; // 月
        let day = date.getDate(); // 日
        let week = date.getDay(); // 星期
        let weekArr = [ "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六" ];
        let hour = date.getHours(); // 时
        hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
        let minute = date.getMinutes(); // 分
        minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
        let second = date.getSeconds(); // 秒
        second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
        this.nowDate = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
        var currentDate
        if(format == "yyyy/MM/dd mm:hh:ss week"){
        currentDate = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
        }
        if(format == "yyyy-MM-dd mm:hh:ss"){
            currentDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }
        return currentDate
        // return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second
       
        },
        getTimeData(val) { //   获取时间并格式化
            // 获取前val天的时间
            var dt = new Date;
            val === 0 ? '' : dt.setTime(dt.getTime() + val * 60 * 60 * 1000)
            const y = dt.getFullYear();
            const m = (dt.getMonth() + 1 + "").padStart(2, "0");
            const d = (dt.getDate() + "").padStart(2, "0");
            const hh = (dt.getHours() + "").padStart(2, "0");
            const mm = (dt.getMinutes() + "").padStart(2, "0");
            const ss = (dt.getSeconds() + "").padStart(2, "0");
            return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;  // 获取的时间格式为 2021-04-09 09:34:00
            },
        // 判断是否为微信浏览器
        isWeixinBrowser() {
            let ua = navigator.userAgent.toLowerCase();
            return /micromessenger/.test(ua) ? true : false;
        },
        // 页面返回公共事件
        reback(url){
            return vue.$router.push(url)
        },
        encode(str) {
            // 首先，我们使用 encodeURIComponent 来获得百分比编码的UTF-8，然后我们将百分比编码转换为原始字节，最后存储到btoa里面
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                function toSolidBytes(match, p1) {
                    return String.fromCharCode(Number('0x' + p1));
                }));
        },
        decode(str) {
            // 过程：从字节流到百分比编码，再到原始字符串
            return decodeURIComponent(atob(str).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        },
        // 秒转位分
        convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
        /**
	 * 题库题型区分
	 * @param {String} type   1、单选；2、多选；3、判断；4、填空；5、问答；6、不定项选择；7、排序；8、匹配；9、完形填空
	 * 
	 */
        getTopicType(type){
            const actionTypelanes = {
                0:'',
                1:'单选题',
                2:'多选题',
                3:'判断题',
                4:'填空题',
                5:'问答题',
                6:'不定项选择题',
                7:'排序题',
                8:'匹配题',
                9:'完形填空题',
            }
            return actionTypelanes[type]
        },
        offType(type){
            const Typelanes = {
              '1':'和隆优化官网',
              '2':'和隆软件官网',
              '1,2':'和隆优化官网 ｜ 和隆软件官网',
              '2,1':'和隆优化官网 ｜ 和隆软件官网',
          }
          return Typelanes[type]
      }
}
